/** ----------------------------------------
     Module Interface
 ---------------------------------------- */

import module from './interface';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {

    /** ----------------------------------------
         All Jobs
     ---------------------------------------- */

    getJobs: state => {
        return state.data;
    },

    /** ----------------------------------------
        Job Amount
     ---------------------------------------- */

    getJobsAmount: state => {
        return state.data.length;
    }

};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters